/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// Fix: フィルター・ソート変更時の白画面問題を修正（Findter対応版）
(function() {
  var lastUrl = location.href;

  // URLが変わったら強制リロード
  function checkUrlChange() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      if (location.href.indexOf('/collections/') !== -1 && location.href.indexOf('?') !== -1) {
        location.reload();
      }
    }
  }

  // popstate（ブラウザ履歴変更）を監視
  window.addEventListener('popstate', function() {
    checkUrlChange();
  });

  // pushState/replaceStateをフック
  var _pushState = history.pushState;
  history.pushState = function() {
    _pushState.apply(history, arguments);
    checkUrlChange();
  };

  var _replaceState = history.replaceState;
  history.replaceState = function() {
    _replaceState.apply(history, arguments);
    checkUrlChange();
  };
})();
